function bindNewsletterForms() {
  document.querySelectorAll('form.newsletter-onesignal').forEach((form) => {
    if (form.dataset.newsletterOnesignalBound) return;
    form.dataset.newsletterOnesignalBound = '1';

    form.addEventListener('submit', () => {
      window.OneSignalDeferred = window.OneSignalDeferred || [];
      window.OneSignalDeferred.push((OneSignal) => {
        try {
          OneSignal.User.addTags({ signup_source: 'email-form-homepage' });
        } catch (err) {
          console.warn('[newsletter] OneSignal tag write failed:', err);
        }
      });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bindNewsletterForms);
} else {
  bindNewsletterForms();
}
